import { LanguageVO } from './language.vo';
import { TranslatableLabelVO } from './../common/translation/translatable-label.vo';
import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { Country, Language, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { AttachmentService } from '../../command/core/attachment/attachment.service';
import { Observable } from 'rxjs';
import { ViewData } from '../../model/view.data';
import { IVo, entity, field } from '@wizeoo/akm-compute-lib';

/*** VO pays */
@entity('wizeoo.allkey.locale.message.Country', 'BU')
export class CountryVO implements IVo {
  /**
   * Le VO source provenant du back
   */
  private _source: Country;

  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }

  constructor(model: Model, pSource?: Country) {
    this._model = model;
    this._source = null;
    if (pSource) {
      this._source = pSource;
    } else {
      this._source = new Country();
      this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
    }
  }

  public set source(country: Country) {
    this._source = country;
  }
  public get source(): Country {
    return this._source;
  }

  public set uid(uid: string) {
    this._source.uid = uid;
  }
  public get uid(): string {
    return this._source.uid;
  }

  // Id technique
  public get id(): number {
    return this._source.id;
  }
  public set id(value: number) {
    this._source.id = value;
  }

  public set domain(domain: string) {
    this._source.domain = domain;
  }

  public get domain(): string {
    return this._source.domain;
  }

  @field('string')
  public set code(code: string) {
    this._source.code = code ? code.toUpperCase() : code;
  }
  public get code(): string {
    return this._source.code;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this._source.label = value;
  }
  public get label(): TranslatedEmb {
    return this._source.label;
  }

  @field('boolean')
  public get deprecated(): boolean {
    return this._source.deprecated;
  }
  public set deprecated(value: boolean) {
    this._source.deprecated = value;
  }

  @field('boolean')
  public get deleted(): boolean {
    return this._source.deleted;
  }
  public set deleted(value: boolean) {
    this._source.deleted = value;
  }

  public set businessUnitCode(businessUnitCode: string) {
    this._source.businessUnitCode = businessUnitCode;
  }
  public get businessUnitCode(): string {
    return this._source.businessUnitCode;
  }

  /** collection de langues */
  @field('Language', true)
  public get languages(): Language[] {
    if (!this._source.languages) {
      this._source.languages = {};
    }
    return Object.values(this._source.languages);
  }
  public set languages(languages: Language[]) {
    this._source.languages = {};
    // convertion de Language[] en {[key: string]: Language}
    languages.map((language) => {
      this._source.languages[language.code] = language;
    });
  }

  @field('string')
  public get icon(): string {
    return this._source.icon;
  }

  public set icon(pValue: string) {
    this._source.icon = pValue;
  }


  /**
   * Accès au libellé traduit
   */
  public get trsLabel(): string {
    return this.model.localeEngine.translate(this.label, this.code);
  }


  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = this.model.localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /**
   * Concaténation code+libellé pour les tris
   */
  public get filterLabel(): string {
    let result: string = this.code;
    if (!result) {
      result = '';
    }
    if (this.trsLabel) {
      result += '|' + this.trsLabel;
    }
    return result;
  }

  /** retourne l'icone si existe, sinon le média par défaut */
  public get iconOrDie(): Observable<string> {
    return AttachmentService.getInstance().iconOrDie(this.icon, ViewData.wildcardDomainLiteral, ViewData.wildcardDomainLiteral, ViewData.wildcardMainVision);
  }

  /** Rendu Code- label */
  public get codeAndLabelStr(): string {
    const label = this.trsLabel ? this.trsLabel : '';
    return this.code + ' - ' + label;
  }

  /** Le pays est-il persisté? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this._source.id > 0;
  }

  /** accesseur sur la liste des langues en mode VO */
  public get languagesVO(): LanguageVO[] {
    let result: LanguageVO[] = null;
    if (this.languages && this.model.languageMap) {
      result = this.languages.map((lg) => this.model.languageMap.get(lg.code));
    }
    return result;
  }

  /** Setter de la liste de langues en mode VO */
  public set languagesVO(value: LanguageVO[]) {
    let result: Language[] = null;
    if (value) {
      result = value.map((cn) => cn.source);
    }
    this.languages = result;
  }
}
